import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DiscussionService } from '../../../../shared-service/services/discussion.service';

@Component({
  selector: 'comment-section',
  templateUrl: './comment-section.component.html',
  styleUrls: ['./comment-section.component.css']
})
export class CommentSectionComponent implements OnInit {

  @Input()
  discussForum:any;

  discuss_id:any;
  results=[];
  totalComments:any;
  isParent=true;
  showLoadMore=true;
  pageIndex=0;

  constructor(
    private route: ActivatedRoute,
    public discussionService: DiscussionService,
  ) { }

  ngOnInit() {
    this.discuss_id = this.discussForum.forum_id;
    this.discussionService.getChildCommentByDiscussionId(this.discuss_id, 0,this.pageIndex).subscribe(
      (res:any) => {
        if(res.data) {
          this.results = res.data;
          this.pageIndex +=1;
          this.totalComments = res.count;
        }
      }
    );
  }

  loadMoreComments() {
    this.discussionService.getChildCommentByDiscussionId(this.discuss_id,0, this.pageIndex).subscribe(
      (res:any) => {
        if(res.data) {
          this.results = [...this.results,...res.data];
          this.pageIndex +=1;
        } else {
          this.showLoadMore = false;
        }
      }
    );
  }

  refreshCommentSection(event) {
    //this.results = [...this.results,...event];
    this.removeExistingComments(event);
  }

  removeExistingComments(event) {
     var refreshComments=[];
     event.forEach(loadedComment => {
        let isExisting=false;
        for(var ind=0; ind<this.results.length; ind++) {
          if(this.results[ind].id == loadedComment.id) {
            isExisting=true;
            ind=this.results.length;
          }
        }
        if(!isExisting) {
          refreshComments.push(loadedComment);
        }
      });
      this.results = [...this.results,...refreshComments];
  }

}
